import axios from "axios";

export const customerDetails = async () => {
    let res = await axios.get('/customer')
    return res.data;
}
